import { AnyObject } from "../../models";
import TabBar from "./TabBar";
import Item from "./Item";

type TabBarComponent = typeof TabBar & {
  Item: typeof Item;
};

const Component = TabBar as AnyObject;
Component.Item = Item;

export default Component as TabBarComponent;
